import { Controller, useFormContext } from 'react-hook-form';
import { Box, Checkbox, FormControlLabel, FormGroup, InputLabel, Text } from '@hopskipdrive/react-components';
import { lowerFirst } from 'lodash';

import { colorTokens } from '../../../../shared/components/variables';
import { useReportsQuery } from '../../../hooks/useReportsQuery';
import { FilterInfo } from '../../../types';

import { StyledFormGroupSx } from './StatusFilter.styles';

export const StatusFilter = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FilterInfo>();
  const { staticFilters } = useReportsQuery();

  return (
    <>
      <InputLabel htmlFor="status">Filter by Status</InputLabel>
      <Box display="flex" flexDirection="column" className={!!errors.statuses ? 'hasError' : ''}>
        <FormGroup sx={StyledFormGroupSx}>
          <Controller
            name="statuses"
            control={control}
            defaultValue={[]}
            render={({ field: { onChange, value } }) => {
              return (
                <>
                  {staticFilters &&
                    staticFilters?.statuses.map((status, index) => (
                      <FormControlLabel
                        key={index}
                        aria-label={`Group by ${status.label} status`}
                        control={
                          <Checkbox
                            sx={{ ml: '20px' }}
                            id={`${lowerFirst(status.label.replaceAll(' ', ''))}Status`}
                            data-testid={`${lowerFirst(status.label.replaceAll(' ', ''))}Status`}
                            value={status.value}
                            checked={value?.includes(status.value)}
                            onChange={(event, checked) => {
                              if (checked) {
                                onChange([...value, event.target.value]);
                              } else {
                                onChange(value.filter((value) => value !== event.target.value));
                              }
                            }}
                          />
                        }
                        label={status.label}
                      />
                    ))}
                </>
              );
            }}
          />
        </FormGroup>
        {!!errors.statuses && (
          <Text
            variant="bodyS"
            fontWeight={300}
            style={{ fontSize: '12px', lineHeight: 'normal', color: colorTokens.error.dark }}
          >
            {errors.statuses?.message}
          </Text>
        )}
      </Box>
    </>
  );
};
